import React from 'react';
import { CTAButton } from './CTAButton';
export const PricingSection = () => {
  return <section className="w-full bg-white py-10 px-4" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-152">
          Votre Investissement vs Vos Économies
        </h2>
        <div className="flex flex-col md:flex-row gap-6 mb-8" data-id="element-153">
          <div className="md:w-1/2 bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-154">
            <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-155">
              Ce que vous dépensez DÉJÀ chaque mois :
            </h3>
            <ul className="space-y-3" data-id="element-156">
              <li className="flex justify-between" data-id="element-157">
                <span className="text-gray-700" data-id="element-158">
                  Médicaments (Lyrica, gabapentine) :
                </span>
                <span className="font-bold" data-id="element-159">100-200$</span>
              </li>
              <li className="flex justify-between" data-id="element-160">
                <span className="text-gray-700" data-id="element-161">
                  Consultations spécialistes :
                </span>
                <span className="font-bold" data-id="element-162">200-300$ (délai 6-8 mois)</span>
              </li>
              <li className="flex justify-between" data-id="element-163">
                <span className="text-gray-700" data-id="element-164">
                  Une seule visite urgence :
                </span>
                <span className="font-bold" data-id="element-165">300-500$</span>
              </li>
              <li className="flex justify-between" data-id="element-166">
                <span className="text-gray-700" data-id="element-167">Soins infection pied :</span>
                <span className="font-bold" data-id="element-168">400-800$ par épisode</span>
              </li>
            </ul>
          </div>
          <div className="md:w-1/2 bg-blue-50 p-6 rounded-lg shadow-sm" data-id="element-169">
            <div className="bg-blue-600 text-white text-center p-3 rounded-lg mb-4" data-id="element-170">
              <h3 className="text-xl font-bold" data-id="element-171">
                KinéPulse : Seulement 114.99$
              </h3>
              <p data-id="element-172">
                Prix de lancement exclusif - Moins cher qu'un mois de
                médicaments
              </p>
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-4" data-id="element-173">
              En un mois, KinéPulse peut vous faire économiser :
            </h3>
            <ul className="space-y-3" data-id="element-174">
              <li className="flex justify-between" data-id="element-175">
                <span className="text-gray-700" data-id="element-176">Réduction médicaments :</span>
                <span className="font-bold" data-id="element-177">100-200$</span>
              </li>
              <li className="flex justify-between" data-id="element-178">
                <span className="text-gray-700" data-id="element-179">
                  Éviter consultations urgence :
                </span>
                <span className="font-bold" data-id="element-180">300$+</span>
              </li>
              <li className="flex justify-between" data-id="element-181">
                <span className="text-gray-700" data-id="element-182">
                  Meilleur sommeil = plus d'énergie =
                </span>
                <span className="font-bold" data-id="element-183">qualité de vie</span>
              </li>
            </ul>
            <div className="bg-green-100 text-green-800 p-3 rounded mt-4 font-bold text-center" data-id="element-184">
              ROI dès le premier mois
            </div>
          </div>
        </div>
        <div className="bg-blue-50 p-6 rounded-lg shadow-md mb-8" data-id="element-185">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-186">
            Votre Garantie Sans Risque
          </h3>
          <ul className="space-y-3" data-id="element-187">
            <li className="flex items-start" data-id="element-188">
              <div className="h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-189">
                ✓
              </div>
              <p className="text-gray-700" data-id="element-190">
                30 jours satisfait ou remboursé COMPLET
              </p>
            </li>
            <li className="flex items-start" data-id="element-191">
              <div className="h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-192">
                ✓
              </div>
              <p className="text-gray-700" data-id="element-193">
                Support technique en français (Québec)
              </p>
            </li>
            <li className="flex items-start" data-id="element-194">
              <div className="h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-195">
                ✓
              </div>
              <p className="text-gray-700" data-id="element-196">
                Livraison rapide partout au Canada
              </p>
            </li>
            <li className="flex items-start" data-id="element-197">
              <div className="h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-198">
                ✓
              </div>
              <p className="text-gray-700" data-id="element-199">
                Paiement sécurisé sur notre site Shopify
              </p>
            </li>
          </ul>
        </div>
        <div className="bg-yellow-50 p-6 rounded-lg shadow-sm mb-8" data-id="element-200">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-201">
            Bonus Exclusifs Inclus GRATUITEMENT :
          </h3>
          <ul className="space-y-3" data-id="element-202">
            <li className="flex items-start" data-id="element-203">
              <div className="h-6 w-6 rounded-full bg-yellow-500 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-204">
                ★
              </div>
              <p className="text-gray-700" data-id="element-205">
                Guide PDF "Les 7 Erreurs à Éviter avec la Neuropathie" (valeur
                29$)
              </p>
            </li>
            <li className="flex items-start" data-id="element-206">
              <div className="h-6 w-6 rounded-full bg-yellow-500 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-207">
                ★
              </div>
              <p className="text-gray-700" data-id="element-208">
                Accès à notre groupe privé Facebook - Soutien communautaire
              </p>
            </li>
            <li className="flex items-start" data-id="element-209">
              <div className="h-6 w-6 rounded-full bg-yellow-500 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-210">
                ★
              </div>
              <p className="text-gray-700" data-id="element-211">
                Email support prioritaire pour questions d'usage
              </p>
            </li>
          </ul>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg shadow-sm mb-8" data-id="element-212">
          <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-213">
            Il Est Temps de Choisir
          </h3>
          <p className="text-gray-700 mb-6 italic" data-id="element-214">
            "Avec la neuropathie, chaque semaine compte. Plus vous attendez,
            plus les dommages s'accumulent. 30 jours d'essai, c'est largement
            suffisant pour voir si vos nerfs réagissent." - Dr. Martineau
          </p>
          <h4 className="font-bold text-gray-800 mb-3" data-id="element-215">
            La Réalité Financière :
          </h4>
          <p className="text-gray-700 mb-4" data-id="element-216">
            Pensez-y : 114.99$, c'est moins que :
          </p>
          <ul className="list-disc pl-8 mb-6 space-y-2 text-gray-700" data-id="element-217">
            <li data-id="element-218">Une sortie au restaurant pour deux</li>
            <li data-id="element-219">Un mois de Lyrica ou gabapentine</li>
            <li data-id="element-220">Une seule consultation privée</li>
            <li data-id="element-221">Le coût d'une infection au pied</li>
          </ul>
          <p className="text-gray-700 mb-6 font-bold" data-id="element-222">
            Mais ça pourrait vous sauver vos pieds.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-223">
            Vous avez deux choix devant vous :
          </p>
          <div className="space-y-4 mb-6" data-id="element-224">
            <div className="p-4 bg-gray-100 rounded-lg" data-id="element-225">
              <p className="font-bold" data-id="element-226">CHOIX 1 :</p>
              <p className="text-gray-700" data-id="element-227">
                Continuer à dépenser 100-200$ par mois en médicaments qui
                masquent le problème. Espérer que ça n'empire pas.
              </p>
            </div>
            <div className="p-4 bg-blue-100 rounded-lg" data-id="element-228">
              <p className="font-bold" data-id="element-229">CHOIX 2 :</p>
              <p className="text-gray-700" data-id="element-230">
                Investir 114.99$ UNE SEULE FOIS pour essayer de traiter la
                cause. Sans risque pendant 30 jours.
              </p>
            </div>
          </div>
        </div>
        <CTAButton showPrice={true} data-id="element-231" />
      </div>
    </section>;
};